import { Typography } from '@mui/material';
import { PARAGRAPH, SUBTITLE, TITLE } from './constants';

interface TitleProps {
  Title: TITLE;
  Subtitle: SUBTITLE;
  Paragraph: PARAGRAPH;
  Link?: string;
}

const Title = ({ Subtitle, Title, Paragraph, Link }: TitleProps) => {
  return (
    <div>
      <Typography variant="h6" fontSize={'19.2px'} fontWeight={700}>
        {Subtitle}
      </Typography>
      <Typography
        variant="h1"
        fontSize={'47.78px'}
        fontWeight={700}
        lineHeight={'56px'}
        letterSpacing={'-2.389px'}
      >
        {Title}
      </Typography>
      <Typography
        variant="body1"
        fontWeight={400}
        fontSize={'16px'}
        lineHeight={'24px'}
      >
        {Paragraph}{' '}
        {Link && (
          <a href={Link} target="_blank">
            contact.
          </a>
        )}
      </Typography>
    </div>
  );
};

export default Title;
